module.exports = __webpack_public_path__ + "img/PPMP13.1331a9e5.png";